module.exports = __webpack_public_path__ + "static/media/commun-achiev.6a7c6863.png";